export const classPicker = (classes) => {
  let finalClassString = '';
  Object.keys(classes).forEach(key => finalClassString += classes[key] ? `${key} ` : '');
  return finalClassString.trim();
};
export const importStylingAsset = (url) => {
  let element = document.querySelector(`link[href="${url}"]`);
  if (!element) {
    element = document.createElement('link');
    element.setAttribute('rel', 'stylesheet');
    element.setAttribute('href', url);
    document.head.appendChild(element);
  }
};
// TODO: REMOVE, functions already defined on rohan-commons library
const rgbToHsl = (r, g, b) => {
  let d, h, l, max, min, s;
  r /= 255;
  g /= 255;
  b /= 255;
  max = Math.max(r, g, b);
  min = Math.min(r, g, b);
  h = 0;
  s = 0;
  l = (max + min) / 2;
  if (max === min) {
    h = s = 0;
  }
  else {
    d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
    }
    h /= 6;
  }
  h = Math.ceil(h * 360);
  s = (Math.ceil(s * 100)) + "%";
  l = (Math.ceil(l * 100)) + "%";
  return [h, s, l];
};
const hexToRgb = (hex) => {
  if (hex.charAt && hex.charAt(0) === '#') {
    hex = removeHash(hex);
  }
  if (hex.length === 3) {
    hex = expand(hex);
  }
  let bigint = parseInt(hex, 16);
  let r = (bigint >> 16) & 255;
  let g = (bigint >> 8) & 255;
  let b = bigint & 255;
  return [r, g, b];
};
const removeHash = (hex) => {
  let arr = hex.split('');
  arr.shift();
  return arr.join('');
};
function expand(hex) {
  return hex
    .split('')
    .reduce(function (accum, value) {
    return accum.concat([value, value]);
  }, [])
    .join('');
}
export const hexToHsl = (hex) => {
  let hsl = rgbToHsl.apply(rgbToHsl, hexToRgb(hex));
  return [hsl[0], parseInt(hsl[1], 10), parseInt(hsl[2], 10)];
};
export const setupGlobalStyles = (documentObject, config) => {
  const documentStyle = documentObject.documentElement.style;
  if (config.primaryColor) {
    documentStyle.setProperty('--ibk-ds-primary', config.primaryColor);
    const [ph, ps, pl] = hexToHsl(config.primaryColor);
    documentStyle.setProperty('--ibk-ds-primary-light', `hsl(${ph}, ${ps}%, ${pl + 3}%)`);
    documentStyle.setProperty('--ibk-ds-primary-lighter', `hsl(${ph + 1}, ${ps - 37}%, ${pl + 55}%)`);
  }
  if (config.secondaryColor) {
    documentStyle.setProperty('--ibk-ds-secondary', config.secondaryColor);
  }
  if (config.accentColor) {
    documentStyle.setProperty('--ibk-ds-accent', config.accentColor);
  }
  if (config.regularFontName) {
    documentStyle.setProperty('--ibk-ds-regular-font', config.regularFontName);
  }
  if (config.mediumFontName) {
    documentStyle.setProperty('--ibk-ds-medium-font', config.mediumFontName);
  }
  if (config.boldFontName) {
    documentStyle.setProperty('--ibk-ds-bold-font', config.boldFontName);
  }
};
